export type { AllCompaniesProps } from './all-companies';
export * from './all-companies.routes';

export { default as AllCompanies, default } from './all-companies';
